


<div class="tool-chunk" >


    <button mat-icon-button color="primary" (click)="expand()" aria-label="expand to view simuation full screen">
        <i *ngIf='!sim_expanded' class="fa-solid fa-maximize"></i>
        <i *ngIf='sim_expanded' class="fa-solid fa-minimize"></i>
     </button>
    <div class="spacer">

        <h1>Simulation</h1>
        </div>






 </div>



    <!-- <button 
    mat-icon-button
    color="white" 
    (click)="closeSimView()">
    <i class="fa fa-angle-double-right"></i> 
    </button>
 -->


